<div class="dropdown" appDropdownAutoLocate [menuWidth]="data.rect.width" [dropdownWidth]="data.width"
    [rect]="data.rect" *ngIf="user && user.id">
    <app-box-arrow [colorChange]="true" [msgCustomPosition]="true"></app-box-arrow>
    <app-dropdown-login-request *ngIf="user && !user.id"></app-dropdown-login-request>
    <div class="notification-tabs">
        <div class="notification-tab favorites h-100" [ngClass]="{'active': activeTab === 'favorites'}"
            (click)="activeTab = 'favorites'">收藏
            <div class="tab-shadow"></div>
            <div class="favorites-number notranslate" *ngIf="notifications.favorites">
                <span>{{ notifications.favorites >= 99 ? '99+' : notifications.favorites }}</span>
            </div>
        </div>

        <div class="notification-tab follows h-100" [ngClass]="{'active': activeTab === 'follows'}"
            (click)="activeTab = 'follows'">关注
            <div class="tab-shadow"></div>
            <div class="favorites-number notranslate" *ngIf="notifications.follows">
                <span>{{ notifications.follows >= 99 ? '99+' : notifications.follows }}</span>
            </div>
        </div>

        <div class="notification-tab messages h-100" [ngClass]="{'active': activeTab === 'messages'}"
            (click)="activeTab = 'messages'">消息
            <div class="tab-shadow"></div>
            <div class="messages-number notranslate" *ngIf="notifications.messages || concatsHasUnreadMessage.length">
                <span>{{ (notifications.messages + concatsHasUnreadMessage.length) >= 99 ? '99+' : (notifications.messages + concatsHasUnreadMessage.length) }}</span>
            </div>
        </div>
    </div>
  <app-dropdown-notifications-messages [hidden]="activeTab !== 'messages'"></app-dropdown-notifications-messages>
  <app-dropdown-notifications-favorites [hidden]="activeTab !== 'favorites'"> </app-dropdown-notifications-favorites>
  <app-dropdown-notifications-follows [hidden]="activeTab !== 'follows'"> </app-dropdown-notifications-follows>
  <div class="dropdown-bottom"></div>
</div>
